// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsofservice" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;

//        https://spinnerapp.onrender.com/termsofservices
//         https://spinnerapp.onrender.com/privacypolicy
